<life-di-nav></life-di-nav>

<div *ngIf="measure" class="container py-3">

  <div class="row d-flex justify-content-center">
    <div class="col-lg-10 col-md-10 col-sm-12 col-12">
      <div *ngIf="measure.CAN_EDIT" class="d-flex justify-content-between">
        <div class="my-3">
          <select class="custom-select form-control my-2" [(ngModel)]="measureStatus" (change)="status()">
            <option value="public">public</option>
            <option value="private">private</option>
          </select>
        </div>
        <div class="my-3">
          <div class="d-flex justify-content-between">
            <button class="btn btn-primary text-center mr-3" style="width: 45px;" (click)="edit(measureID)">
              <img src="assets/edit-w.png" style="width: 20px;" alt="">
            </button>
            <button class="btn btn-success text-center mr-3 pt-1 py-2" style="width: 45px;" (click)="duplicate()">
              <img src="assets/duplicate-white.png" style="width: 20px;" alt="">
            </button>
            <button class="btn btn-danger pt-1 py-2" style="width: 45px;" (click)="delete()">
              <img src="assets/delete(white).png" style="width: 20px;" alt="">
            </button>
          </div>
        </div>
      </div>
      <h3 class="text-center my-5" style="color: #2D2A4A;"
        [ngClass]="measure.FONT === 'arial' ? 'Arial' : measure.FONT === 'times-new-roman' ? 'TimeNewRoman' : measure.FONT === 'calibri' ? 'Calibri' : measure.FONT === 'comic-sans-ms' ? 'ComicSansMS' : measure.FONT === 'th-sarabun' ? 'THSarabun-Header' : measure.FONT === 'K2D' ? 'K2D' : ''">
        {{ measureName }}
      </h3>

      <hr width="100%">

      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">

          <div *ngFor="let item of measure.details">
            <div *ngIf="item.TYPE === 'multi_choice'">
              <lifedi-multiple-choice [multipleChoice]="item" [font]="measure.FONT">
              </lifedi-multiple-choice>
            </div>

            <div *ngIf="item.TYPE === 'rating'">
              <lifedi-rating-choice [ratingChoice]="item" [font]="measure.FONT">
              </lifedi-rating-choice>
            </div>

            <div *ngIf="item.TYPE === 'ranking'">
              <lifedi-ranking-choice [ranking]="item" [font]="measure.FONT">
              </lifedi-ranking-choice>
            </div>

            <div *ngIf="item.TYPE === 'most/least'">
              <lifedi-most-least-choice [mostLeastData]="item" [font]="measure.FONT">
              </lifedi-most-least-choice>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading">
    <div
      style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
  </div>
</div>
